import { SelectionPanelGroup, SelectionPanelGroupTheme, SelectionPanelBorderRadius, SelectionPanelDropShadowType } from '@apply/components';
import type { SelectionPanelProps } from '@apply/components';
import { GCRoleType, GCRoleTypeOptions } from '@apply/constants';
import { AuthorizedDrawUserDto } from '@apply/api/src/api/ApplyApi';

export interface DrawUserRadioPanelGroupProps {
    selectedUserIds: string[];
    setSelectedUserIds: React.Dispatch<React.SetStateAction<string[]>>;
    users: AuthorizedDrawUserDto[];
}
export const DrawUserRadioPanelGroup: React.FC<DrawUserRadioPanelGroupProps> = ({
    selectedUserIds,
    setSelectedUserIds,
    users,
}) => {
    const renderOption = (name: string, role: GCRoleType | undefined) => {
        return (
            <>
                <div className='item'>
                    <div className='itemContent'>
                        <div className='itemTitle'>{name}</div>
                        <div className='itemSubtitle'>{GCRoleTypeOptions.find((o) => o.id === role)?.name}</div>
                    </div>
                </div>
            </>
        );
    };

    const radioOptions = (users: AuthorizedDrawUserDto[]): SelectionPanelProps[] => {
        return users.map((user) => ({
            id: user.userId,
            children: renderOption(`${user.displayFirstName} ${user.displayLastName}`, user.displayRole),
        }));
    };

    return (
        <SelectionPanelGroup
            id='drawUserSelectionGroup'
            items={radioOptions(users)}
            theme={SelectionPanelGroupTheme.Blue}
            selectedPanels={selectedUserIds}
            set_selectedPanels={setSelectedUserIds}
            borderRadius={SelectionPanelBorderRadius.Small}
            dropShadowType={SelectionPanelDropShadowType.Small}
        />
    );
};
